import script from "./EstabelecimentoPesquisaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EstabelecimentoPesquisaModal.vue?vue&type=script&setup=true&lang=js"

import "./EstabelecimentoPesquisaModal.vue?vue&type=style&index=0&id=2a38f48b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a38f48b"]])

export default __exports__